import { FC } from 'react'

import { CheckmarkIcon, PersonOnPersonFullIcon } from '@inno-ui/icons'
import { BasicIconProps } from '@inno-ui/icons/lib/Icons.types'
import { TFunction } from 'i18next'

interface PackageFeature {
  icon: FC<BasicIconProps>
  text: string
  isBold?: boolean
}

export interface PackageDetailsData {
  title: string
  features: PackageFeature[]
  pricing: {
    price: string
    duration: string
  }
}

export const getPackageDetailsData = (
  t: TFunction<'auth', 'package_details.card'>
): PackageDetailsData => ({
  title: t('title'),
  features: [
    {
      icon: PersonOnPersonFullIcon,
      text: t('features.account_per_organization'),
      isBold: true
    },
    {
      icon: CheckmarkIcon,
      text: t('features.office_functionality')
    },
    {
      icon: CheckmarkIcon,
      text: t('features.email_calendar')
    },
    {
      icon: CheckmarkIcon,
      text: t('features.project_task_management')
    },
    {
      icon: CheckmarkIcon,
      text: t('features.gdpr_contact_manager')
    },
    {
      icon: CheckmarkIcon,
      text: t('features.employees_inventory')
    },
    {
      icon: CheckmarkIcon,
      text: t('features.team_communication')
    },
    {
      icon: CheckmarkIcon,
      text: t('features.time_tracking')
    },
    {
      icon: CheckmarkIcon,
      text: t('features.company_database')
    }
  ],
  pricing: {
    price: t('pricing.price'),
    duration: t('pricing.duration')
  }
})
